import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";

export default function useDeleteTeamMember(shopId: string, userId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("delete", "/shops/{shopId}/members/{userId}");

  return useMutation({
    onSuccess: () => {
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async () => {
      return mutation.mutateAsync({
        params: { path: { userId, shopId } },
      });
    },
  });
}
